export default __webpack_public_path__ + "static/media/service2.f9e99b98.jpg";